import { useApp } from '@hb/react'
import { BloodPressure, EncounterType, quickNoteField, RiskAssessment } from '@hb/shared'
import { useCallback } from 'react'
import { saveEncounter } from '../../../../backend/functions/gyn'
import { GenericEditModal } from '../../../../components/DataView/GenericEditModal'
import { useGynCareView } from '../../../../components/Gyn/context'

interface Props {
  assessmentId: string
  patientId: string
  isOpen: boolean
  onClose: () => void
}

export const QuickNoteModal = ({ assessmentId, patientId, isOpen, onClose }: Props) => {
  const { appName } = useApp()
  const { practiceId } = useGynCareView()

  const handleSubmit = useCallback(
    async (data: Record<string, any>) => {
      if (!practiceId) return { error: 'Practice not found' }
      try {
        const bp = data.bloodPressure as BloodPressure | undefined
        const vital: Record<string, any> = {}
        if (bp?.systolic && bp?.diastolic) vital.bloodPressure = bp
        if (data.pulse != null) vital.pulse = data.pulse
        if (data.temperature != null) vital.temperature = data.temperature
        if (data.weight != null) vital.weight = data.weight

        await saveEncounter({
          appName,
          encounterId: null,
          type: EncounterType.ANTEPARTUM,
          patientId,
          practiceId,
          assessmentId,
          config: { visitType: 'routine' },
          date: new Date().toISOString().slice(0, 10),
          riskAssessment: 'no-risk' as RiskAssessment,
          data: {
            ...(Object.keys(vital).length > 0 ? { vital } : {}),
            ...(data.fundalHeightCm != null ? { fundalHeightCm: data.fundalHeightCm } : {}),
            ...(data.fetalHeartTones != null ? { fetalHeartTones: data.fetalHeartTones } : {}),
            ...(data.fetalPosition ? { fetalPosition: data.fetalPosition } : {}),
            ...(data.edema ? { edema: data.edema } : {}),
            ...(data.quickNoteText ? { quickNoteText: data.quickNoteText } : {}),
            quickNoteOrigin: true,
          },
        })
        return { success: 'Quick Note saved' }
      } catch {
        return { error: 'Failed to save Quick Note' }
      }
    },
    [appName, assessmentId, patientId, practiceId],
  )

  return (
    <GenericEditModal
      isOpen={isOpen}
      onClose={onClose}
      field={quickNoteField}
      data={{}}
      onSubmit={handleSubmit}
      subheader="Saves as a draft encounter. Open the full note to complete and authenticate."
      submitText="Save Quick Note"
    />
  )
}
